<ng-sidebar-container>
  <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" position="right" [animate]="sideBarAnimate" [keyClose]="false">
    <div class="sidebar-fix" >
      <div *ngIf="selected!=null">
        <div class="sidebar header-spacing"></div>
        <ngx-form-module title="Enabled" [(value)]="selected.active"></ngx-form-module>

        <ngx-form-text title="Full Name" [(value)]="selected.name"></ngx-form-text>
        <!--<ngx-form-list-contact [(value)]="selected.contact" ></ngx-form-list-contact>-->
        <ngx-form-text title="Username" [(value)]="selected.username"></ngx-form-text>
        <ngx-form-text title="Short" [(value)]="selected.short"></ngx-form-text>

        <!-- <div class="row">
          <div class="col-4">
            <label>Contact</label>
          </div>
          <div class="col-8">
            <ng2-completer
              [(ngModel)]="selectedContactName"
              [datasource]="contactService"
              [minSearchLength]="0"
              (selected)="selectContact($event)"
              inputClass="form-control form-control-sm"
            ></ng2-completer>
          </div>
        </div> -->

        <!-- <div class="row">
          <div class="col-4">
            <label>Contact</label>
          </div>
          <div class="col-8"> -->
            <ngx-doc-form-filter-select
              title="Contact"
              [noBorder]="true"
              [options]="combinedContactOptions"
              [(value)]="$any(selected).contact"></ngx-doc-form-filter-select>
          <!-- </div>
        </div> -->

        <ngx-form-password *ngIf="changePassword" title="Reset Password" [(value)]="selected.hash"></ngx-form-password>
        <ngx-form-module *ngIf="!changePassword" title="Reset Password" [(value)]="changePassword"></ngx-form-module>

        <ng-container *ngIf="auth.user.admin && selected.erpRoles">
          <ngx-form-module title="Administrator" [(value)]="selected.admin"></ngx-form-module>
          <ngx-form-module title="Login Admin" [(value)]="selected.erpRoles.loginAdmin"></ngx-form-module>
          <ngx-form-module title="No CRM" [(value)]="selected.erpRoles.noCrm"></ngx-form-module>
          <ngx-form-module title="Business" [(value)]="selected.erpRoles.business"></ngx-form-module>
          <ngx-form-module title="PFSPO Availability" [(value)]="selected.erpRoles.availability"></ngx-form-module>
          <ngx-form-module title="Offers (Menu)" [(value)]="selected.erpRoles.offersMenu"></ngx-form-module>
          <ngx-form-module title="Open Orders" [(value)]="selected.erpRoles.openorders"></ngx-form-module>
          <ngx-form-module title="Warehousing" [(value)]="selected.erpRoles.warehousing"></ngx-form-module>
          <ngx-form-module title="Open Invoices" [(value)]="selected.erpRoles.openinvoices"></ngx-form-module>
          <!-- <ngx-form-module title="Dashboard" [(value)]="selected.erpRoles.dashboard"> -->
          <div class="row" *ngIf="selected?.erpRoles">
            <div class="col-4">
              <label><b>Business overview</b></label>
            </div>
            <div class="col-sm-2">
              <ui-switch color="#c89712" [(ngModel)]="selected.erpRoles.dashboard"></ui-switch>
            </div>
            <div class="col-sm-2" style="padding-top:0.7em;padding-right:1em">
              <label style="padding-right:0.7em;">Overview RSM</label>
              <input name="dashboardtype" type="radio" [(ngModel)]="selected.erpRoles.dashboardType" [value]="1" [attr.disabled]="selected.erpRoles.dashboard ? null : true">
            </div>
            <div class="col-sm-2" style="padding-top:0.7em;padding-right:1em">
              <label style="padding-right:0.7em;">Overview all</label>
              <input name="dashboardtype" type="radio" [(ngModel)]="selected.erpRoles.dashboardType" [value]="2" [attr.disabled]="selected.erpRoles.dashboard ? null : true">
            </div>
          </div>
          <ngx-form-module title="Test server access" [(value)]="selected.erpRoles.testServerAccess"></ngx-form-module>
          <ngx-form-module title="Include in Sales Report" [(value)]="selected.erpRoles.salesReport"></ngx-form-module>
      
          <nb-card *ngIf="selected.erpRoles">
            <nb-card-header>ERP roles</nb-card-header>
            <nb-card-body>
              <ngx-form-module title="ERP Administrator" [(value)]="selected.erpRoles.admin" (valueChange)="onErpAdminChange($event)"></ngx-form-module>
              <ngx-form-module title="ERP Materials" [(value)]="selected.erpRoles.materials"
                (valueChange)="!$event && selected.erpRoles.readOnlyMaterials = false" 
                secondTitle="read only:" [(secondValue)]="selected.erpRoles.readOnlyMaterials"
                (secondValueChange)="$event && $any(selected.erpRoles).material = true" [disabled]="selected.erpRoles.admin"></ngx-form-module>
              <ngx-form-module title="ERP Products (Base & Finished)" [(value)]="selected.erpRoles.products"
                (valueChange)="!$event && selected.erpRoles.readOnlyProducts = false" 
                secondTitle="read only:" [(secondValue)]="selected.erpRoles.readOnlyProducts"
                (secondValueChange)="$event && selected.erpRoles.products = true" [disabled]="selected.erpRoles.admin"></ngx-form-module>
              <ngx-form-module title="ERP NRKA (Documents & Price Matrix)" [(value)]="selected.erpRoles.nrka" 
                (valueChange)="!$event && selected.erpRoles.readOnlyNrka = false" 
                secondTitle="read only:" [(secondValue)]="selected.erpRoles.readOnlyNrka"
                (secondValueChange)="$event && selected.erpRoles.nrka = true" [disabled]="selected.erpRoles.admin">
              </ngx-form-module>
              <ngx-form-module title="ERP NRKG (Documents & Price Matrix)" [(value)]="selected.erpRoles.nrkg"
                (valueChange)="!$event && selected.erpRoles.readOnlyNrkg = false" 
                secondTitle="read only:" [(secondValue)]="selected.erpRoles.readOnlyNrkg"
                (secondValueChange)="$event && selected.erpRoles.nrkg = true" [disabled]="selected.erpRoles.admin">
              </ngx-form-module>
              <ngx-form-module title="ERP Reports" [(value)]="selected.erpRoles.reports" [disabled]="selected.erpRoles.admin"></ngx-form-module>
              <ngx-form-module title="ERP Business report" [(value)]="selected.erpRoles.customerReport" [disabled]="selected.erpRoles.admin"></ngx-form-module>
              <!-- <ngx-form-module title="ERP Offers" [value]="selected.erpRoles.offers !== 4" [disabled]="selected.erpRoles.admin" (valueChange)="offersChanged($event)"></ngx-form-module> -->
              <div class="row">
                <div class="col-4"><label><b>ERP Offers</b></label></div>
                <div class="col-sm-2">
                  <ui-switch color="#c89712" [ngModel]="selected.erpRoles.offers !== 0" (ngModelChange)="offersChanged($event)"></ui-switch>
                </div>
                <div class="col-4 pt-2" *ngIf="selected.erpRoles.offers !== 0">
                  <input class="ml-3 mr-1" type="radio" nme="offerType" [(ngModel)]="selected.erpRoles.offers" [value]="1" (ngModelChange)="selected.erpRoles.offers=1" />All
                  <input class="ml-3 mr-1" type="radio" nme="offerType" [(ngModel)]="selected.erpRoles.offers" [value]="2" (ngModelChange)="selected.erpRoles.offers=2" />BU
                  <input class="ml-3 mr-1" type="radio" nme="offerType" [(ngModel)]="selected.erpRoles.offers" [value]="3" (ngModelChange)="selected.erpRoles.offers=3" />Customers
                </div>
              </div>
            </nb-card-body>
          </nb-card>


          <ngx-form-list title="Roles" [(value)]="selected.roles" [columns]="roleColumns" (editConfirm)="validate($event)"></ngx-form-list>
          <!--<div *ngFor="let m of selected.modules">
            <ngx-form-module [name]="m.text" [(value)]="m.enabled"></ngx-form-module>
            <div *ngFor="let v of m.values">
              <div *ngIf="m.enabled">
                <ngx-form-check *ngIf="v.type == EValueType.checkbox" [name]="v.name" [(value)]="v.value"></ngx-form-check>
                <ngx-form-text *ngIf="v.type == EValueType.text" [name]="v.name" [(value)]="v.value"></ngx-form-text>
              </div>
            </div>
          </div>-->

        </ng-container>

        <div class="sidebar header-spacing"></div>
        <div class="sidebar header">
          <div class="row">
            <div class="col-md-12">
              <h1> {{selected.username}}</h1>
            </div>
          </div>
        </div>
        <div class="sidebar footer">
          <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-8">
              <button class="btn btn-default btn-lg" (click)="cancel(selected)">Cancel</button>
              <button class="btn btn-primary btn-lg" (click)="save(selected)">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-sidebar>

  <div ng-sidebar-content>
    <ngx-page-container>
      <h1>Users</h1>
      <hr>

      <button class="btn btn-primary btn-sm pull-right" (click)="create()">+</button>
      <table class="table table-hover">
        <thead>
        <tr>
          <th scope="col">Username</th>
          <th scope="col">Name</th>
          <th scope="col">Short</th>
          <th scope="col">Status</th>
          <th scope="col">Role</th>
          <th scope="col">Last Updated</th>

          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of data.users | paginate: { itemsPerPage: 14, currentPage: p }"
            [ngClass]="{'table-active': item === selected}"
            (click)="select(item)">
          <td>{{item.username}}</td>
          <td>{{item.name}}</td>
          <td>{{item.short}}</td>
          <td>{{item.active ? "Enabled" : "Disabled"}}</td>
          <td>{{item.admin ? 'Admin' : 'Default' }}</td>
          <td>{{$any(item).updatedAt  | date: 'dd. MM. yyyy'}}</td>
          <td>
            <button class="btn btn-default btn-sm" (click)="toggleSidebar(item)"><i class="ion-edit"></i></button>
            <!--<div class="dropdown" ngbDropdown>
              <button class="btn btn-default btn-sm btn-dropdown noarrow" type="button" ngbDropdownToggle>
                <i class="ion-more"></i>
              </button>
              <ul class="nrk-dropdown-menu" ngbDropdownMenu>
                <li class="dropdown-item" (click)="toggleSidebar(item)"><i class="ion-edit"></i>&nbsp;Bearbeiten</li>
                <li class="dropdown-item" (click)="toggleActive(item)"><i class="ion-flag"></i>&nbsp;{{ !item.active?"Aktiv":"Inaktiv"}} setzen</li>
              </ul>
            </div>-->
          </td>
        </tr>
        </tbody>
      </table>
      <pagination-controls (pageChange)="p = $event"></pagination-controls>
    </ngx-page-container>
  </div>
</ng-sidebar-container>
